"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_FONTS = exports.SITE_STYLES = void 0;
exports.SITE_STYLES = 'SITE_STYLES';
exports.SITE_FONTS = 'SITE_FONTS';
//# sourceMappingURL=styleIds.js.map